import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7411abae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "messages" }, null, -1))
const _hoisted_2 = { class: "controls two-columns" }
const _hoisted_3 = { class: "fields clearfix" }
const _hoisted_4 = { class: "left-column" }
const _hoisted_5 = { class: "form-group form-group-with-icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Full Name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-control-border" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_9 = { class: "form-group form-group-with-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Address", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-control-border" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_13 = { class: "form-group form-group-with-icon" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Subject", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-control-border" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_17 = { class: "right-column" }
const _hoisted_18 = { class: "form-group form-group-with-icon" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Message", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-control-border" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_ModalA = _resolveComponent("ModalA")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.sendMail()), ["prevent"])),
      class: "contact-form"
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
                id: "form_name",
                type: "text",
                name: "name",
                class: "form-control",
                placeholder: "",
                required: "required",
                "data-error": ""
              }, null, 512), [
                [_vModelText, _ctx.fullName]
              ]),
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                id: "form_email",
                type: "email",
                name: "email",
                class: "form-control",
                placeholder: "",
                required: "required",
                "data-error": ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subject) = $event)),
                id: "form_subject",
                type: "text",
                name: "subject",
                class: "form-control",
                placeholder: "",
                required: "required",
                "data-error": ""
              }, null, 512), [
                [_vModelText, _ctx.subject]
              ]),
              _hoisted_14,
              _hoisted_15,
              _hoisted_16
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                id: "form_message",
                name: "message",
                class: "form-control",
                placeholder: "",
                rows: "7",
                required: "required",
                "data-error": ""
              }, null, 512), [
                [_vModelText, _ctx.message]
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ])
          ])
        ]),
        _createVNode(_component_vue_recaptcha, {
          class: "g-recaptcha",
          sitekey: "6LdaozggAAAAACVblndN4-eeqz6rY9akqTdglN1R",
          size: "normal",
          theme: "dark",
          onVerify: _ctx.recaptchaVerified,
          onExpire: _ctx.recaptchaExpired,
          ref: "vueRecaptcha"
        }, null, 8, ["onVerify", "onExpire"]),
        _createElementVNode("button", {
          class: "button btn-send tw-px-2",
          value: "Send message",
          disabled: _ctx.submitDisabled
        }, "Send message", 8, _hoisted_22)
      ])
    ], 32),
    _createVNode(_component_ModalA, {
      "modal-active": _ctx.modalActive,
      onCloseModal: _ctx.toggleModal
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.successMessage), 1)
      ]),
      _: 1
    }, 8, ["modal-active", "onCloseModal"])
  ]))
}